import styled, { css } from 'styled-components';

import { fontSizes, fontWeights } from '../../../../theme';
import { ElementSize } from '../../../../types';
import { ButtonPrimitive } from '../../../Button';
import getInputIconStyles from '../../utils/getInputIconStyles';
import mapInputSizeToThemeSize from '../../utils/mapInputSizeToThemeSize';

export const InputElement = styled.input<{ $size: ElementSize }>`
  ${({ theme, $size, disabled }) => css`
    box-sizing: border-box;
    width: 100%;
    padding: 0;
    font-weight: ${fontWeights.regular};
    font-size: ${$size === 'small' ? fontSizes.xs : fontSizes.m};
    background: inherit;
    color: inherit;
    border: none;
    outline: none;
    box-shadow: none;
    line-height: ${theme.core.iconSize.m};

    cursor: ${disabled && 'not-allowed'};
    caret-color: currentcolor;

    &::placeholder {
      color: ${theme.components.Input.placeholder[
        mapInputSizeToThemeSize($size)
      ]['fg-default']};
    }
  `}
`;

export const TogglePasswordButton = styled(ButtonPrimitive)`
  ${({ theme, disabled }) => css`
    box-sizing: border-box;
    padding: 0;
    outline: none;
    border: none;
    border-radius: ${theme.core.radius.x};
    background-color: inherit;

    cursor: pointer;

    &:focus-visible {
      outline: 1px solid ${theme.core.color.neutral[500]};
    }

    width: ${theme.core.iconSize.m};
    height: ${theme.core.iconSize.m};

    > svg {
      ${getInputIconStyles(theme, disabled)}
    }
  `}
`;
